import { type GraphPath, IPF_NO_VALUE_CLOUD } from '@ipfabric/utils';
import type { ReactNode } from 'react';
import { GraphNetworkViewerNoValueIcon } from './GraphNetworkViewerNoValueIcon';

export const getPathNameIcon = (path: GraphPath): ReactNode =>
  path === IPF_NO_VALUE_CLOUD ? <GraphNetworkViewerNoValueIcon /> : null;
